import i18n from 'i18next'
import { formatNumber } from '../../packages/utils/numberFormatters'

const quantityLabelKeys = {
    right: ['pages.issues.quantityLabels.right', 'pages.issues.quantityLabels.rights'],
    share: ['pages.issues.quantityLabels.share', 'pages.issues.quantityLabels.shares'],
    unit: ['pages.issues.quantityLabels.unit', 'pages.issues.quantityLabels.units'],
    warrant: ['pages.issues.quantityLabels.warrant', 'pages.issues.quantityLabels.warrants'],
}

const label = (type, quantity, locale) => {
    const [singularKey, pluralKey] = quantityLabelKeys[type]
    const text = i18n.t(quantity === 1 ? singularKey : pluralKey)
    return `${formatNumber(quantity, { locale, decimals: 0 })} ${text}`
}

const quantityLabel = (issue, quantity, locale) => {
    return label(isUnit(issue) ? 'unit' : 'share', quantity, locale)
}

const rightsQuantityLabel = (quantity, locale) => label('right', quantity, locale)
const sharesQuantityLabel = (quantity, locale) => label('share', quantity, locale)
const unitsQuantityLabel = (quantity, locale) => label('unit', quantity, locale)
const warrantsQuantityLabel = (quantity, locale) => label('warrant', quantity, locale)

function isUnit(issue) {
    if (issue.type === 'Rights issue' || issue.type === 'IPO') {
        // maybe unit
        return issue.hasWarrant || issue.warrants?.length > 0 || issue.sharesInUnit !== 1 || issue.unitExtraContent
    } else {
        // always share
        return false
    }
}

const isShare = (issue) => !isUnit(issue)

export {
    isShare,
    isUnit,
    quantityLabel,
    rightsQuantityLabel,
    sharesQuantityLabel,
    unitsQuantityLabel,
    warrantsQuantityLabel,
}
